import React, { useState } from 'react'
import { Rate, notification, Modal, Input } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'
import './index.scss'

const REQUIRES_COMMENT_RATING_THRESHOLD = 3
const COMMENT_MAX_LENGTH = 255

const rateProductDeliveryMutation = gql`
  mutation SetProductDeliveryRating($input: SetProductDeliveryRatingInput!) {
    SetProductDeliveryRating(input: $input) {
      product {
        id
        deliveryRating {
          id
          rating
        }
      }
    }
  }
`

const RateProductDelivery = ({ product }) => {
  const { id, deliveryRating = {} } = product
  const existingRating = (deliveryRating && deliveryRating.rating) || 0
  const [pendingRating, setPendingRating] = useState(null)
  const [ratingComment, setRatingComment] = useState('')
  const [modalIsVisible, setModalIsVisible] = useState(false)

  const [setProductDeliveryRating, { loading }] = useMutation(
    rateProductDeliveryMutation,
    {
      onCompleted: (_response) => {
        notification.success({
          message: 'Din vurdering ble lagret!',
        })
      },
      onError: (err) => {
        console.log('err:', err)
        notification.error({
          message: err.message,
        })
      },
    }
  )

  const handleChange = (val) => {
    if (val > 0 && val <= REQUIRES_COMMENT_RATING_THRESHOLD) {
      setPendingRating(val)
      setModalIsVisible(true)
    } else {
      submit(val, null)
    }
  }

  const submit = (rating, comment) => {
    setProductDeliveryRating({
      variables: {
        input: {
          productId: id,
          deliveryRating: {
            rating,
            comment,
          },
        },
      },
    })
  }

  return (
    <>
      <div className="rating">
        <Rate
          count={6}
          disabled={loading}
          value={existingRating}
          onChange={handleChange}
        />
        {loading && <LoadingOutlined />}
      </div>
      <Modal
        title="Kommenter på lav rating"
        visible={modalIsVisible}
        onOk={() => {
          submit(pendingRating, ratingComment)
          setModalIsVisible(false)
        }}
        okButtonProps={{ disabled: !ratingComment }}
        onCancel={() => {
          setModalIsVisible(false)
        }}
      >
        <p>
          Du har valgt å gi en lav rating på {pendingRating}. Vennligst klargjør
          hvorfor under.
        </p>
        <Input.TextArea
          value={ratingComment}
          onChange={(e) => {
            if(e.target.value.length <= COMMENT_MAX_LENGTH) {
              setRatingComment(e.target.value)
            }
          }}
          placeholder="Skriv inn kommentar"
        />
        <div>
          {ratingComment.length}/{COMMENT_MAX_LENGTH}
        </div>
      </Modal>
    </>
  )
}

export default RateProductDelivery
